import { Button, Typography } from '@packages/ui/shared';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type DiagnosticInfoModalProps = {
    onHide: () => void;
    show: boolean;
};

export function DiagnosticInfoModal({ onHide, show }: DiagnosticInfoModalProps) {
    const { t } = useTranslation();

    return (
        <Modal centered onHide={onHide} show={show}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t('qmr:sections.failCode.cvtDiagnostic.infoModal.title', 'About the CVT Diagnostic Test')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Typography>
                    {t(
                        'qmr:sections.failCode.cvtDiagnostic.infoModal.body',
                        "When the fail code is CVT-related, the report must include a CVT diagnostic test which is what supports the fail code you selected.\n\nOnly diagnostic tests run in the last 30 days can be used. If there is one for this VIN, it's attached automatically. If there isn't, or the most recent one is older than that, you'll need to run a new diagnostic test before submitting."
                    )}
                </Typography>
            </Modal.Body>

            <Modal.Footer>
                <Button onPress={onHide} variant="primary">
                    {t('qmr:sections.failCode.cvtDiagnostic.infoModal.gotIt', 'Got it')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
